export default "__VITE_ASSET__f9e08b7a__"